import React, { Component } from "react";
import Translation from '../../../common/translation/translation.component'
import { removeDomainName } from  '../../../../utils/helpers.utils';
import Avatar from "../../../common/avatar/Avatar";

export class ActiveSubscriber extends Component {

    
    render() {
        const { onClickItemActiveSubscriber, otherSubscribersList } = this.props;
        return (
            otherSubscribersList.length <= 0 ?<p className="string-result-style"> <Translation translationKey="no_results_found" /> </p>: otherSubscribersList.map((item, id) =>
                <div
                    key={id}
                    data-index={item.EmployeeId}
                    className={`active-subscriber-container active-subscriber-item`}
                    onClick={onClickItemActiveSubscriber}
                    >
                    <Avatar className="tab-client-logo" src={item.LogoPath} text={item.FullName} />
                    <div className="tab-details">
                        <h1 className="tab-details-phonenumber">{item.FullName}</h1>
                        <h2 className="tab-details-office">{item.EId}</h2>
                        <h2 className="tab-details-office">{item.Location}</h2>
                    </div>
                </div>
            )
        );
    }
}